import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useOffers from 'tennders-market/offer/hooks/useOffers'
import GLoading from 'tennders-market/common/components/element/GLoading'
import GCurrency from 'tennders-market/common/components/element/GCurrency'

function InternalOffers() {
  const { transaction } = useTransaction()
  const { getInternalOffers } = useOffers()
  const [items, setitems] = useState([])
  const [loading, setloading] = useState(true)
  const { t } = useTranslation()

  useEffect(async () => {
    if (transaction) {
      const response = await getInternalOffers(transaction)
      setitems(response)
      setloading(false)
    }
  }, [transaction])

  return (
    loading
      ? <GLoading />
      : (
        items.length > 0 && (
          <>
            <h3 className="bold"><Trans i18nKey="offer:internalOffers" /></h3>
            <table className="tennders-table-zebra text-center">
              <thead>
                <tr className="border-b">
                  <th className="text-left">Name of Broker</th>
                  <th>Price</th>
                  <th>Date &amp; Time</th>
                  <th>Payment Terms</th>
                  <th>Pickup Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  items.map((item) => (
                    <tr key={item?.id} className="border-b">
                      <td className="text-left">{item.owner}</td>
                      <td><GCurrency value={item?.bid} /></td>
                      <td>{item?.date}</td>
                      <td>{item?.paymentTerms ? `${item?.paymentTerms} ${t('common:days')}` : 'Original Terms'}</td>
                      <td>{item?.routes?.pickupRoute?.date?.d}</td>
                      <td><Trans i18nKey={`offer:status_${item?.status?.label}`} /></td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            <div className="hr" />
          </>
        )
      )
  )
}

export default InternalOffers
